import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Text, HStack} from '@chakra-ui/react3'
import {DeliveryTruckIcon} from '../../../leap/components/icons'
import {InfoIconTooltip} from '../../../components/info-icon-tooltip'
import {InfoIconFilled} from '../../../components/icons'
import useOcapiSite from '../../../hooks/useOcapiSite'
import {ESTIMATED_DELIVERY_HELPER_TEXT} from '../../../constants'

const EstimatedDelivery = ({product}) => {
    const {formatMessage} = useIntl()
    const {parcelLabShippingEstimateEnabled} = useOcapiSite().preferences

    const c_estimatedDelivery = product?.c_estimatedDelivery
    if (!c_estimatedDelivery) return null

    return (
        <HStack spacing={2} alignItems="center">
            <DeliveryTruckIcon role="presentation" boxSize={4} />
            <Text textStyle="body.xsmall">
                {formatMessage(
                    {
                        id: 'checkout.shipping.delivery_time',
                        defaultMessage: 'Delivery from: {time}',
                        description:
                            'The date range when delivery is expected to happen. {time} contains range like "24.11.2021 - 26.11.2021"'
                    },
                    {time: product.c_estimatedDelivery}
                )}
            </Text>
            {parcelLabShippingEstimateEnabled && (
                <InfoIconTooltip
                    name={'delivery'}
                    helpText={formatMessage(ESTIMATED_DELIVERY_HELPER_TEXT)}
                    icon={InfoIconFilled}
                />
            )}
        </HStack>
    )
}

EstimatedDelivery.propTypes = {
    product: PropTypes.object
}

export default EstimatedDelivery
